import type {
	FormKitContext,
	FormKitNode,
	FormKitTypeDefinition,
} from "@formkit/core";
import { $if, prefix } from "@formkit/inputs";
import { nextTick } from "vue";

function isRecord(value: unknown): value is Record<PropertyKey, unknown> {
	return value !== null && typeof value === "object";
}

function isOptionalGroupEnabled(value: unknown) {
	if (!isRecord(value)) {
		return false;
	}

	return String(value.Volgnummer) === "1";
}

function createEnabledGroupValue(value: unknown) {
	return {
		...(isRecord(value) ? value : {}),
		Volgnummer: 1,
	};
}

function syncGroupEnabled(node: FormKitNode, value: unknown) {
	if (!node.context) {
		return;
	}

	node.context.groupEnabled = isOptionalGroupEnabled(value);
}

function getContextValue(context: FormKitContext) {
	return context._value ?? context.value;
}

function optionalGroupFunctionality(node: FormKitNode) {
	node.on("created", ({ payload }) => {
		if (!node.context) {
			return;
		}

		syncGroupEnabled(node, getContextValue(payload));
		void nextTick(() => {
			syncGroupEnabled(node, node.value);
		});

		node.context.fns.enableGroup = () => {
			if (isOptionalGroupEnabled(node.value)) {
				return;
			}

			void node.input(createEnabledGroupValue(node.value));
		};

		node.context.fns.disableGroup = () => {
			node.context!.groupEnabled = false;
			void node.input({});
		};
	});

	node.on("input", ({ payload }) => {
		syncGroupEnabled(node, payload);
	});

	node.on("commit", ({ payload }) => {
		syncGroupEnabled(node, payload);
	});
}

export const optionalGroup: FormKitTypeDefinition = {
	type: "group",
	schema: $if("$groupEnabled", () => "$slots.default", prefix()),
	features: [optionalGroupFunctionality],
};
